import { useQuery } from '@tanstack/react-query';
import { headlessGet } from '../lib/api';
import type { EntryDetailResponse } from '../types/cms';

export function useCollectionEntry(typeSlug: string | undefined, slug: string | undefined) {
  return useQuery({
    queryKey: ['entry', typeSlug, slug],
    queryFn: () =>
      headlessGet<EntryDetailResponse>(
        `/collections/${encodeURIComponent(typeSlug!)}/${encodeURIComponent(slug!)}`,
      ),
    enabled: !!typeSlug && !!slug,
    staleTime: 60_000,
    retry: false,
  });
}
